import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAuth} from "../hooks/useAuth";
import UserRole from "../../schemas/user/roles";
import Loading from "../../components/status/Loading";

interface RoleBasedRouteProps {
    allowedRoles: UserRole[];
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({allowedRoles}) => {
    const {isAuthenticated, isLoading, hasPermission} = useAuth();
    const location = useLocation();

    if (isLoading) return <Loading/>;

    if (!isAuthenticated) return <Navigate to="/login" state={{from: location}}/>;

    const isAuthorized = allowedRoles.some(role => hasPermission(role));
    if (!isAuthorized) return <Navigate to="/forbidden" state={{from: location}}/>;

    return <Outlet/>;
};

export default RoleBasedRoute;